// extracted by mini-css-extract-plugin
module.exports = {"photo2":"FeedPhotosItem_photo2__1ADd9","photo":"FeedPhotosItem_photo__3R_l7","visualizacao":"FeedPhotosItem_visualizacao__3C6Qy"};